/**
 * Comprehensive product access — production go-live.
 * Agents buy COMP; underwriting (all) + super_admin can issue/manage COMP and extensions.
 */

export const COMP_PILOT_SUPER_ADMIN_EMAIL = 'dnjatha@monarchinsurance.co.ke';

/** @deprecated Kept for reference only — COMP is open to all underwriters. */
export const COMP_PILOT_UNDERWRITER = Object.freeze({
  username: 'CGICHEHA',
  email: 'cgicheha@monarchinsurance.co.ke',
  role: 'underwriting'
});

function norm(v) {
  return String(v || '').trim().toLowerCase();
}

export function staffIdentity(user) {
  return {
    role: norm(user?.role || user?.adminRole),
    email: norm(user?.email),
    username: norm(user?.username)
  };
}

/** Staff who may issue COMP for agents / use underwriting COMP tools. */
export function canAccessComprehensiveInternal(user) {
  const { role } = staffIdentity(user);
  return role === 'super_admin' || role === 'underwriting' || role === 'admin';
}

/** Side-nav / overview / Continuations for underwriting staff. */
export function canSeeComprehensiveUnderwritingNav(user) {
  const { role } = staffIdentity(user);
  return role === 'underwriting' || role === 'super_admin';
}

/** Agents (and staff acting as agents) may purchase COMP. */
export function canPurchaseComprehensive(user) {
  if (!user) return true; // agent CoverPurchase often has agent profile
  const { role } = staffIdentity(user);
  if (!role) return true;
  return (
    role === 'agent' ||
    role === 'employee' ||
    role === 'underwriting' ||
    role === 'super_admin' ||
    role === 'admin'
  );
}
